module.exports = __webpack_public_path__ + "img/hmg03_samurai01skin_shop.67316bad.png";